
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'HeroLayout',
  props: {
    hideLogo: { default: false, type: Boolean },
    bodyMaxWidth: { default: 'sm:max-w-sm', type: String },
    centerHero: { default: true, type: Boolean },
    connectionAsset: { type: String },
    connectionAssetLabel: { type: String },
    bgGradient: {
      default: 'radial-gradient(circle at center, #121317 0%, #16181d 100%)',
      type: String
    }
  },
  computed: {
    cssVars() {
      return {
        '--bg-gradient': this.bgGradient
      }
    }
  }
})
